<template>
	<div :class="{ editor: true, showHelp: helpIsVisible }">
		<div class="SettingsSettingsContainer" v-if="!externalHelpToggle">
			<label class="helpToggleLabel">
				<input type="checkbox" v-model="showHelp" /> <span>Show Editor Help</span>
			</label>
		</div>
		<PropEdit ref="fields" v-for="pair in itemPairs" :key="pair.spec.key" :initialValue="pair.initialValue" :spec="pair.spec" @valueChanged="onValueChanged"
				  class="propEdit" v-show="pair.show" />
	</div>
</template>

<script>
	import PropEdit from 'appRoot/vues/common/editor/PropEdit.vue';

	export default {
		components: { PropEdit },
		props:
		{
			object: {
				type: Object,
				required: true
			},
			spec: {
				type: Array,
				required: true
			},
			/**
			 * If true, this component does not render its own "Show Editor Help" checkbox and instead takes the
			 * help visibility from the [helpVisible] prop.  Used by pages that host the toggle themselves (e.g. the
			 * Admin Settings page, which keeps it in a panel pinned to the top right of the viewport).
			 */
			externalHelpToggle: {
				type: Boolean,
				default: false
			},
			/**
			 * Whether the per-field help text is shown.  Only used when [externalHelpToggle] is true.
			 */
			helpVisible: {
				type: Boolean,
				default: false
			}
		},
		data()
		{
			return {
				specMap: {},
				showHelp: false,
				recomputeItemPairs: 0
			};
		},
		computed:
		{
			helpIsVisible()
			{
				return this.externalHelpToggle ? this.helpVisible : this.showHelp;
			},
			itemPairs()
			{
				if (this.recomputeItemPairs)
				{
				}
				let arr = [];
				for (let i = 0; i < this.spec.length; i++)
				{
					let spec = this.spec[i];
					let initialValue = this.object[spec.key];
					if (typeof initialValue === "undefined")
						initialValue = spec.value;
					let obj = { initialValue: initialValue, spec: spec, show: true };
					if (spec.conditions && spec.conditions.length)
					{
						// The field is shown if ANY of its conditions evaluates true (see ConditionalDisplay.cs).
						obj.show = spec.conditions.some(condition => this.evaluateCondition(condition));
					}
					arr.push(obj);
				}
				return arr;
			}
		},
		methods:
		{
			onValueChanged(key, value)
			{
				this.recomputeItemPairs++;
				this.$emit("valueChanged", key, value);
			},
			focusFirst() // Called by parent component
			{
				if (this.$refs.fields && this.$refs.fields.length > 0)
					this.$refs.fields[0].focus();
			},
			getValue(key, keyIsLiteralValue)
			{
				return keyIsLiteralValue ? key : this.object[key];
			},
			evaluateCondition(condition)
			{
				try
				{
					let A = this.getValue(condition.A, condition.A_Is_Literal);
					let B = this.getValue(condition.B, condition.B_Is_Literal);
					if (typeof A === "undefined")
						A = "";
					if (typeof B === "undefined")
						B = "";
					let Operator = condition.Operator;
					switch (Operator)
					{
						case "Equals":
							return A.toString() === B.toString();
						case "NotEquals":
							return A.toString() !== B.toString();
						case "LessThan":
							return A < parseFloat(B);
						case "LessThanOrEqual":
							return A <= parseFloat(B);
						case "GreaterThan":
							return A > parseFloat(B);
						case "GreaterThanOrEqual":
							return A >= parseFloat(B);
						case "StartsWith":
							return A.toString().startsWith(B.toString());
						case "EndsWith":
							return A.toString().endsWith(B.toString());
						default:
							console.error("Unknown operator:", Operator);
							return true;
					}
				}
				catch (ex)
				{
					console.error("Error while evaluating FieldEditSpec.condition:", JSON.stringify(condition), ex);
				}
				return true;
			}
		},
		created()
		{
		},
		mounted()
		{
		},
		beforeUnmount()
		{
		}
	};
</script>

<style scoped>
	.SettingsSettingsContainer
	{
		display: inline-block;
		background: linear-gradient(to bottom, #FFFFFF, #F2F6F9);
		padding: 8px 12px;
		border: 1px solid #B7C9D6;
		border-left: 4px solid var(--primary-color);
		border-radius: 6px;
		margin-bottom: 16px;
	}

	.helpToggleLabel
	{
		display: flex;
		align-items: center;
		gap: 8px;
		cursor: pointer;
		user-select: none;
		font-weight: bold;
		color: var(--primary-color-text);
		white-space: nowrap;
	}

		.helpToggleLabel input
		{
			width: 16px;
			height: 16px;
			margin: 0px;
			accent-color: var(--primary-color);
			cursor: pointer;
		}

	/* Each field is a row of the form; a hairline rule and a hover tint keep long lists of settings readable. */
	.propEdit
	{
		border-top: 1px solid #EAEFF3;
	}

		.propEdit:first-child
		{
			border-top: none;
		}

		.propEdit:hover
		{
			background-color: #F6FAFD;
		}
</style>
